import { SOGetOrganization } from '../organization/so-get-organization';


export class SOPostMedia {

  constructor(
    public organization: SOGetOrganization,
    public name: string = "",
    public description: string = "",
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPostMedia(
      'name' in params ? params.name : null,
      'description' in params ? params.description : null,
      'organization' in params ? params.organization : null,
    );
  }
}
